import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Detail from './Details';
import { some } from 'lodash';
import Section from '../Section';
import { useTranslation } from 'hooks';
import {
  EmptySection,
  EmptyText
} from 'components/pages/ResumePage/sections/CompetenceProfile/Form/style.js';
import { joinPath } from 'utils/path';

function CompetenceProfile({ className, editPath, competenceProfile, language }) {
  const location = useLocation();
  const { industryFocuses, managementMethods, specialistFocuses } = competenceProfile;
  const { tr } = useTranslation();

  const emptySection = (
    <EmptySection>
      <EmptyText>{tr('message.sectionIsEmpty')}</EmptyText>
      <EmptyText>{tr('message.addMoreInformation')}</EmptyText>
    </EmptySection>
  );

  const industryFocusesData = useMemo(() => industryFocuses[language], [
    competenceProfile,
    language
  ]);
  const managementMethodsData = useMemo(() => managementMethods[language], [
    competenceProfile,
    language
  ]);
  const specialistFocusesData = useMemo(() => specialistFocuses[language], [
    competenceProfile,
    language
  ]);

  // Convert object to string for Detail prop
  const competenceProfileData = useMemo(
    () => ({ industryFocusesData, managementMethodsData, specialistFocusesData }),
    [industryFocusesData, managementMethodsData, specialistFocusesData]
  );

  const path = useMemo(() => {
    return editPath ? joinPath(editPath, 'competence-profile') : '';
  }, [editPath]);

  const editPathState = useMemo(() => ({ background: location }), [location]);

  const data = [
    !!(industryFocusesData && industryFocusesData.length),
    !!(managementMethodsData && managementMethodsData.length),
    !!(specialistFocusesData && specialistFocusesData.length)
  ];

  return (
    <Section
      className={className}
      editPath={path}
      editPathState={editPathState}
      title="title.competenceProfile"
    >
      {some(data) ? <Detail competenceProfile={competenceProfileData} /> : emptySection}
    </Section>
  );
}

CompetenceProfile.propTypes = {
  className: PropTypes.string,
  editPath: PropTypes.string,
  competenceProfile: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired
};

export default CompetenceProfile;
